import { createApp } from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import router from "./router";
import firebase from "firebase/app";
import "firebase/auth";

// import store from "./store";

// createApp(App).use(store).use(router).mount("#app");

const firebaseConfig = {
  apiKey: "AIzaSyCkhycWOAdb3xthlVWJRBUw4-nsiYYqXjw",
  authDomain: "polkadotrodeo.firebaseapp.com",
  databaseURL: "https://polkadotrodeo.firebaseio.com",
  projectId: "polkadotrodeo",
  storageBucket: "polkadotrodeo.appspot.com",
  messagingSenderId: "1099018292690",
  appId: "1:1099018292690:web:6eb33db1ddd781416f8c0b",
};

firebase.initializeApp(firebaseConfig);

createApp(App).use(router).mount("#app");
